import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  VStack,
  Input,
  Select,
  Button,
  FormControl,
  FormLabel,
  Heading,
  IconButton,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  Text,
  Tag,
  Avatar,
  Grid,
  GridItem,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Textarea,
  Tabs,
  TabList,
  Tab,
  HStack,
} from "@chakra-ui/react";
import "./ProfileSetting.scss";
import { useDispatch, useSelector } from "react-redux";
import { getAllSectors } from "../../actions/sector/sectorActions";
import {
  getUserDetail,
  updateUserProfile,
} from "../../actions/user/userActions";
import { SmallAddIcon } from "@chakra-ui/icons";
import { USER_PROFILE_TABS } from "../../constants/ui";
import MyProfileIcon from "../../components/Icons/MyProfileIcon";
import PaymentsIcon from "../../components/Icons/PaymentsIcon";
import MyReferalsIcon from "../../components/Icons/MyReferalsIcon";
import Loader from "../../components/Loader/Loader";
import MyProfile from "./MyProfile";
import Payments from "./Payments";
import ReferralsPage from "./ReferralsPage";

const ClientBackgroundLinks = ({ currentTab, changeTab }) => {
  return (
    <Box>
      <Box m={"0px"} w={"100%"}>
        <Text
          className={
            currentTab === USER_PROFILE_TABS.MY_PROFILE
              ? "SMEBackgroundSubTabs tab-selected"
              : "SMEBackgroundSubTabs"
          }
          style={{ display: "flex" }}
          _hover={{}}
          onClick={() => changeTab(USER_PROFILE_TABS.MY_PROFILE)}
        >
          <Box mr={"5px"}>
            <MyProfileIcon
              color={
                currentTab === USER_PROFILE_TABS.MY_PROFILE
                  ? "#FFFFFF"
                  : "#5D5D5D"
              }
            />
          </Box>
          <Box>My Profile</Box>
        </Text>
      </Box>
      <Box m={"0px"} w={"100%"}>
        <Text
          className={
            currentTab === USER_PROFILE_TABS.PAYMENTS
              ? "SMEBackgroundSubTabs tab-selected"
              : "SMEBackgroundSubTabs"
          }
          style={{ display: "flex" }}
          _hover={{}}
          onClick={() => changeTab(USER_PROFILE_TABS.PAYMENTS)}
        >
          <Box mr={"5px"}>
            <PaymentsIcon
              color={
                currentTab === USER_PROFILE_TABS.PAYMENTS
                  ? "#FFFFFF"
                  : "#5D5D5D"
              }
            />
          </Box>
          <Box>Payments</Box>
        </Text>
      </Box>
      <Box m={"0px"} w={"100%"}>
        <Text
          className={
            currentTab === USER_PROFILE_TABS.MY_REFERALS
              ? "SMEBackgroundSubTabs tab-selected"
              : "SMEBackgroundSubTabs"
          }
          style={{ display: "flex" }}
          _hover={{}}
          onClick={() => changeTab(USER_PROFILE_TABS.MY_REFERALS)}
        >
          <Box mr={"5px"}>
            <MyReferalsIcon
              color={
                currentTab === USER_PROFILE_TABS.MY_REFERALS
                  ? "#FFFFFF"
                  : "#5D5D5D"
              }
            />
          </Box>
          <Box>MY Referals</Box>
        </Text>
      </Box>
    </Box>
  );
};


const TabContent = ({ tab, clientData }) => {
  switch (tab) {
    case USER_PROFILE_TABS.MY_PROFILE:
      return <MyProfile/>;
    case USER_PROFILE_TABS.PAYMENTS:
      return <Payments/>;
    case USER_PROFILE_TABS.MY_REFERALS:
      return <ReferralsPage />;
  }
};

const Profile = () => {

  const [currentTab, setCurrentTab] = useState(USER_PROFILE_TABS.MY_PROFILE);

  const changeTab = (newTab) => {
    setCurrentTab(newTab);
  };

  return (
    <>
      <Flex style={{ padding: "5px 10px" }} justifyContent={"end"}>
        <Text
          fontStyle="italic"
          px={2}
          fontSize="var(--sylvr-h4-fs)"
          fontWeight="var(--sylvr-h5-fw)"
          color="var(--sylvr-text-color)"
        >
          SME profile 50% complete. Make it 100 to unlock profile
          discoverability
        </Text>
      </Flex>

      <Box margin="0px" className="SMEBackgroundBoxShadow">
        <HStack
          w={"100%"}
          spacing={4}
          alignItems={"start"}
          className="shadowBox"
        >
          <Box w={"200px!important"} h="350px" overflowY={"auto"}>
            <VStack
              // w={'70%'}
              spacing={4}
              m={1}
              className="leftNavOptions"
              alignItems={"center"}
              p="10px 3px"
            >
              <ClientBackgroundLinks
                currentTab={currentTab}
                changeTab={changeTab}
                // clientData={clientDetails?.clientDetails}
              />
            </VStack>
          </Box>
          <Box mt={2} w={"80%"}>
            <TabContent tab={currentTab} />
          </Box>
        </HStack>
      </Box>
    </>
  );
};

export default Profile;
